export enum PageContent {
  ACTIVITY = 'activity',
  PRODUCTS = 'products',
}
